import React, { useEffect } from "react";
import Servicebanner from "../../Services/Servicebanner";
import NumberInfo from "../../Home/NumberInfo";
import Doctorbox from "../../Home/Docterbox";
import Divser from "../../About/Divser";
import Divider from "../../Divider";
import ServiceReview from "../../Services/ServiceReview";
import Callin from "../../About/Callin";
import Infiry from "../../About/Infiry";
import { movetop } from "../../../fun";
import Dentalcon from "./Dentalcon";
import { Helmet } from "react-helmet-async";

function Dentalser() {
  type elem = {
    oneBody?: JSX.Element;
    twoBody?: JSX.Element;
    threeBody?: JSX.Element;
  };
  const elemnt: elem = {
    oneBody: <Dentalcon />,
    twoBody: <Infiry />,
    threeBody: <Callin />,
  };

  useEffect(() => {
    movetop();
  }, []);
  return (
    <>
      <Helmet>
        <title>Best Dental Clinic in Vijayanagar</title>
        <meta
          name="description"
          content="Are you looking for the best Dental Clinic in Vijayanagar? Then you are at the right place. Feel free to contact us today."
        />
        <meta
          name="keywords"
          content="Best Dental Clinic in Whitefield, Best Dental Clinic in Vijayanagar, healthcare services in Whitefield, healthcare services in Vijayanagar, Multispeciality Clinic in Vijayanagar"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id":
              "https://www.elvhealthcare.com/bestdentalinwhitefield#organization",
            name: "ELV Health Care Polyclinics",
            url: "https://www.elvhealthcare.com/bestdentalinwhitefield",
            description:
              "ELV Health Care Polyclinics in Whitefield offers expert dental care services including routine checkups, preventive dentistry, restorative treatments, cosmetic dentistry, and emergency dental care with modern equipment and experienced dentists.",
            logo: "https://www.elvhealthcare.com/favicon.ico",
            telephone: "+91-9535264855",
            email: "elvhealthcare@gmail.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "MR ASTER, Ground Floor, Vijayanagar, Whitefield",
              addressLocality: "Bengaluru",
              addressRegion: "Karnataka",
              postalCode: "560066",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 12.9764418,
              longitude: 77.7583566,
            },
            hasMap: "https://maps.app.goo.gl/C1xXW4kQyTxR8Sug9",
            knowsAbout: [
              "Routine dental checkups and exams",
              "Preventive dental care & oral hygiene",
              "Restorative dentistry (fillings, crowns)",
              "Cosmetic dental treatments",
              "Teeth whitening and polishing",
              "Emergency dental services",
              "Periodontal therapy and gum care",
            ],
            keywords: [
              "best dental in Immadihalli",
              "best dental in Whitefield",
              "best dental in Bangalore",
              "best dental in Kundalahalli",
              "best dental in Pattandur Agrahara",
            ],
          })}
        </script>
      </Helmet>

      <h2 style={{ display: "none" }}>
        Best Dental Clinic in Vijayanagar emphasizing both the health and
        aesthetics of your smile. We are the best dental clinic in Vijayanagar.
        Contact us today.
      </h2>

      <Servicebanner name="Dental care" banner={"../photo/dd4.jpg"} />
      <NumberInfo test="test-black" />
      <Doctorbox />
      <Divser elemnt={elemnt} />
      {/* <div className="pt-6">
            <Divider />
          </div>
          <Doctorbox /> */}
      <div className="pt-10 pb-4">
        <Divider />
      </div>
      <ServiceReview />
    </>
  );
}

export default Dentalser;
